<template>
  <div v-if="show" class="makey-badge" :style="containerStyle">
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.8254 4.892H13.9965V8.56709H10.1498V4.892H9.1748L12.0001 0L14.8254 4.892ZM11.9758 5.45178C11.4245 5.45178 10.9776 5.89855 10.9776 6.44966C10.9776 7.00076 11.4245 7.44753 11.9758 7.44753C12.527 7.44753 12.9739 7.00076 12.9739 6.44966C12.9739 5.89855 12.527 5.45178 11.9758 5.45178ZM11.9758 2.82325C11.4245 2.82325 10.9776 3.27001 10.9776 3.82112C10.9776 4.37223 11.4245 4.81899 11.9758 4.81899C12.527 4.81899 12.9739 4.37223 12.9739 3.82112C12.9739 3.27001 12.527 2.82325 11.9758 2.82325Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.892 9.17468L4.892 10.0036L8.56709 10.0036L8.56709 13.8503L4.892 13.8503L4.892 14.8253L-1.235e-07 12L4.892 9.17468ZM5.45178 12.0244C5.45178 12.5757 5.89855 13.0226 6.44965 13.0226C7.00076 13.0226 7.44753 12.5757 7.44753 12.0244C7.44753 11.4731 7.00076 11.0262 6.44965 11.0262C5.89855 11.0262 5.45178 11.4731 5.45178 12.0244ZM2.82325 12.0244C2.82325 12.5757 3.27001 13.0226 3.82112 13.0226C4.37223 13.0226 4.81899 12.5757 4.81899 12.0244C4.81899 11.4731 4.37223 11.0262 3.82112 11.0262C3.27001 11.0262 2.82325 11.4731 2.82325 12.0244Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19.108 14.8253L19.108 13.9964L15.4329 13.9964L15.4329 10.1497L19.108 10.1497L19.108 9.17468L24 12L19.108 14.8253ZM18.5482 11.9756C18.5482 11.4243 18.1015 10.9774 17.5503 10.9774C16.9992 10.9774 16.5525 11.4243 16.5525 11.9756C16.5525 12.5269 16.9992 12.9738 17.5503 12.9738C18.1015 12.9738 18.5482 12.5269 18.5482 11.9756ZM21.1768 11.9756C21.1768 11.4243 20.73 10.9774 20.1789 10.9774C19.6278 10.9774 19.181 11.4243 19.181 11.9756C19.181 12.5269 19.6278 12.9738 20.1789 12.9738C20.73 12.9738 21.1768 12.5269 21.1768 11.9756Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.17456 19.108L10.0035 19.108L10.0035 15.4329L13.8502 15.4329L13.8502 19.108L14.8252 19.108L11.9999 24L9.17456 19.108ZM12.0242 18.5482C12.5755 18.5482 13.0224 18.1015 13.0224 17.5503C13.0224 16.9992 12.5755 16.5525 12.0242 16.5525C11.473 16.5525 11.0261 16.9992 11.0261 17.5503C11.0261 18.1015 11.473 18.5482 12.0242 18.5482ZM12.0242 21.1768C12.5755 21.1768 13.0224 20.73 13.0224 20.1789C13.0224 19.6278 12.5755 19.181 12.0242 19.181C11.473 19.181 11.0261 19.6278 11.0261 20.1789C11.0261 20.73 11.473 21.1768 12.0242 21.1768Z"
        fill="white"
      />
    </svg>

    <span class="makey-badge-text">Makey Makey Included!</span>
  </div>
</template>

<script setup>
/* eslint-disable */
const props = defineProps({
  /**
   * Controls badge visibility (replaces v-if at the parent).
   */
  show: {
    type: Boolean,
    default: true,
  },
  /**
   * Extra inline styles forwarded to the badge wrapper
   * (e.g. { marginBottom: "24px" } for the modal variant).
   */
  containerStyle: {
    type: Object,
    default: () => ({}),
  },
});
</script>

<style scoped>
.makey-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 4px 12px;
  background-color: #e00069;
  border-radius: 999px;
  width: max-content;
}

.makey-badge-text {
  font-size: var(--fs-small);
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.035px;
  color: #ffffff;
  white-space: nowrap;
}
</style>
